import React, { useRef } from 'react';
import { Form } from '@unform/web';
import { useDispatch } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { Title, Breadcrumbs, WrapperFlex } from '@unimed-fesp/components';
import * as Yup from 'yup';

import { Creators as ParametroActions } from '../../store/ducks/parametro';
import FormEditParametro from '../../components/organisms/FormEditParametro';
import history from '../../services/history';

import FadeIn from '../../components/atoms/FadeIn';
import theme from '../../styles/theme';

import { Container } from './styles';

const EditParametros = ({ match }) => {
  const formRef = useRef(null);
  const dispatch = useDispatch();
  const { state } = useLocation();

  if (!state || !state?.parametro) {
    history.push('/novo/parametros');
    return <></>;
  }

  const { parametro } = state;
  const { nomeParametrizacao } = match.params;
  const schema = Yup.object().shape({
    ativo: Yup.boolean().required('O status do parametro é obrigatório'),
    descricao: Yup.string().required('A descrição do parametro é obrigatório'),
    valueParametrizacao: Yup.string().required(
      'O value do parametro é obrigatório'
    ),
  });

  async function handleSubmit(data) {
    const bodyRequest = {
      ...data,
      ativo: data.ativo === 'ativo',
    };

    const isValid = await validateData(bodyRequest);

    if (isValid)
      dispatch(
        ParametroActions.patchParametroRequest(
          parametro.idParametrizacao,
          bodyRequest
        )
      );
  }

  async function validateData(data) {
    try {
      const bodyRequest = {
        ...data,
        ativo: data.ativo === 'ativo',
      };

      await schema.validate(bodyRequest, {
        abortEarly: false,
      });
      formRef.current.setErrors({});
      return true;
    } catch (err) {
      const validationErrors = {};
      if (err instanceof Yup.ValidationError) {
        err.inner.forEach((error) => {
          validationErrors[error.path] = error.message;
        });
        formRef.current.setErrors(validationErrors);
      }
      return false;
    }
  }

  return (
    <Container>
      <FadeIn>
        <Title
          text="editar parâmetro"
          color={theme.titleGray}
          fontSize={38}
          marginBottom={8}
        />
        <Breadcrumbs
          crumbs={[
            { path: 'novo' },
            {
              path: 'parametros',
              onNavigate: () => history.push('/novo/parametros'),
            },
            {
              path: nomeParametrizacao,
              onNavigate: () =>
                history.push(`/novo/parametros/editar/${nomeParametrizacao}`),
            },
          ]}
        />
        <WrapperFlex marginTop={25} justifyStart alignStart row>
          <Form ref={formRef} onSubmit={handleSubmit}>
            <FormEditParametro
              parametro={parametro}
              onBlurValidateInputs={validateData}
            />
          </Form>
        </WrapperFlex>
      </FadeIn>
    </Container>
  );
};

export default EditParametros;
